export function fixDefaultCjsImport<T>(brokenDefaultImport: T): T {
  if (
    typeof brokenDefaultImport === 'object' &&
    brokenDefaultImport !== null &&
    '__esModule' in brokenDefaultImport &&
    brokenDefaultImport.__esModule &&
    'default' in brokenDefaultImport
  ) {
    return brokenDefaultImport.default as T;
  }

  console.warn('This dependency no longer needs to be wrapped!');

  return brokenDefaultImport;
}
